import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useAuth } from '@/shared/auth/useAuth';
import { routePaths } from '@/app/router/routePaths';
import { UserMenu } from './UserMenu';

export function TopNav() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <AppBar position="static" elevation={0}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Typography
          variant="h6"
          fontWeight={700}
          color="text.primary"
          sx={{ cursor: 'pointer', letterSpacing: '-0.01em' }}
          onClick={() => navigate(routePaths.djDashboard)}
        >
          Vibe Masters
        </Typography>

        <UserMenu />
      </Toolbar>
    </AppBar>
  );
}
